var map = {
	"./bao1.png": 391,
	"./bao2.png": 392,
	"./bei1.png": 393,
	"./bei2.png": 394,
	"./bg1.gif": 387,
	"./bg2@2x.png": 403,
	"./bg3.png": 404,
	"./bg3@2x.png": 400,
	"./btn2.png": 405,
	"./btn3.png": 406,
	"./buy1.png": 408,
	"./buy2.png": 409,
	"./buyed.png": 410,
	"./close@2x.png": 110,
	"./comfirmBg@2x.png": 401,
	"./goods1.png": 1193,
	"./goods10.png": 216,
	"./goods11.png": 217,
	"./goods12.png": 218,
	"./goods13.png": 219,
	"./goods2.png": 1194,
	"./goods3.png": 1195,
	"./goods4.png": 1196,
	"./goods5.png": 1197,
	"./goods6.png": 1198,
	"./goods7.png": 1199,
	"./goods8.png": 1200,
	"./goods9.png": 142,
	"./goods_bg.png": 397,
	"./gouwucheman@2x.png": 411,
	"./line.png": 399,
	"./remove.png": 220,
	"./select1@2x.png": 389,
	"./select2@2x.png": 390,
	"./single.png": 412,
	"./再想想@2x.png": 214,
	"./折线@2x.png": 1201,
	"./浮标.gif": 1202,
	"./版头@2x.png": 407,
	"./确认打包@2x.png": 402,
	"./限时优惠@2x.png": 395
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 215;


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_135/imgs ^\.\/.*$
// module id = 215
// module chunks = 0